import useDebouncedAction from "@/hooks/useDebouncedAction";
import useGroups from "@/hooks/useGroups";
import { Input } from "@mui/material";
import { useState } from "react";

interface IGroupName {
  groupId: string;
  groupName: string;
}

const GroupName: React.FC<IGroupName> = ({ groupId, groupName }) => {
  const { updateGroupName } = useGroups();

  const [text, setText] = useState(groupName);

  useDebouncedAction([text], () => updateGroupName(text, groupId));

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  return <Input value={text} onChange={onChange} />;
};

export default GroupName;
